module.exports = __webpack_public_path__ + "assets/img/7.358ba378.jpg";